import { render } from "./AddTests.vue?vue&type=template&id=40ae5156"
import script from "./AddTests.vue?vue&type=script&lang=js"
export * from "./AddTests.vue?vue&type=script&lang=js"

import "./AddTests.vue?vue&type=style&index=0&id=40ae5156&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/topdog/labs/panels/AddTests.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "40ae5156"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('40ae5156', __exports__)) {
    console.log('reload')
    api.reload('40ae5156', __exports__)
  }
  
  module.hot.accept("./AddTests.vue?vue&type=template&id=40ae5156", () => {
    console.log('re-render')
    api.rerender('40ae5156', render)
  })

}


export default __exports__